module.exports = __webpack_public_path__ + "static/mykola-cdad7b96d8c8016cdde6fc3af7f0b66d.png";